export default "__VITE_ASSET__Ch5Ud$O9__"